import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import RecipeList from './routes/RecipeList';
import RecipeDetail from './routes/RecipeDetail';
import AdminList from './routes/AdminList';
import AdminEditor from './routes/AdminEditor';
import AdminCategories from './routes/AdminCategories';
import Favourites from './routes/Favourites';

// Client-side navigation doesn't reset scroll, so opening a recipe kept the
// list's scroll offset (you'd land mid-page). Reset to top on every route change.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<RecipeList />} />
          <Route path="recipe/:slug" element={<RecipeDetail />} />
          <Route path="favourites" element={<Favourites />} />
          <Route path="admin" element={<AdminList />} />
          <Route path="admin/new" element={<AdminEditor mode="create" />} />
          <Route path="admin/recipe/:id" element={<AdminEditor mode="edit" />} />
          <Route path="admin/categories" element={<AdminCategories />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}
